module.exports = __webpack_public_path__ + "static/media/firework-blue.1c04e87a.psd";